import { render, staticRenderFns } from "./LocationSelect.vue?vue&type=template&id=3048d94e&scoped=true&"
import script from "./LocationSelect.vue?vue&type=script&lang=js&"
export * from "./LocationSelect.vue?vue&type=script&lang=js&"
import style0 from "./LocationSelect.vue?vue&type=style&index=0&id=3048d94e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3048d94e",
  null
  
)

/* custom blocks */
import block0 from "./LocationSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports